import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector, shallowEqual } from 'react-redux';
import ReducerConstants from '../../../../../_shared/constants/reducers';
import convertToCurrency from '../../../../../_shared/utils/convertToCurrency';
import { TradeState } from '../../../../../_shared/types/trade';

import { StyledTopBidWrapper, StyledTopBidComponent } from './Styles';

const TopBid = ({ maxBid, topBidderSummary, tradeState }) => {
  const [user] = useSelector(
    state => [state[ReducerConstants.AUTH]?.user],
    shallowEqual
  );

  if (![TradeState.pending].includes(tradeState)) {
    return null;
  }
  return (
    <StyledTopBidWrapper>
      <StyledTopBidComponent>
        <FormattedMessage
          id={
            user?.id === topBidderSummary?.id
              ? 'vdp.pending.buyer.label.yourTopBid'
              : 'list.card.negotiation.topBid'
          }
        />
      </StyledTopBidComponent>
      &nbsp;&nbsp;{convertToCurrency(maxBid)}
    </StyledTopBidWrapper>
  );
};

export default TopBid;
